export default "__VITE_ASSET__4ddc3434__"